import { apiWikiAllEntryList } from "@/api/entryApi";

/**
 * 自动将文章内容属于wiki词条的转为链接
 * @param {*} contentDom
 */
export default async function wikiEntryToLink(contentDom, gameAlias, id) {
  try {
    const res = await apiWikiAllEntryList({});
    if (res && res.code == 0) {
      const entryList = res.data || [];
      // console.log(entryList, contentDom);
      loopDomNode(contentDom, entryList, gameAlias, id);
    }
  } catch (error) {
    console.log(error);
  }
}

function loopDomNode(rootNode, entryList, gameAlias, id) {
  for (let i = 0; i < rootNode.childNodes.length; i++) {
    const node = rootNode.childNodes[i];
    // 如果节点是文本节点
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.parentNode.tagName === "A" || node.parentNode.closest("a")) return;
      const text = node.textContent;

      if (text.trim() === "") return;
      let replacedText = text;
      let matchMap = {};
      for (let ei = 0; ei < entryList.length; ei++) {
        const entry = entryList[ei];
        if (entry.id == id) continue;
        let href = `/${gameAlias}/${entry.id}.html`;
        if (!entry.id) {
          href = entry.jump_url;
        }
        const regex = new RegExp(`(${escapeRegExp(entry.name)})`, "g"); // 正则表达式匹配链接地址
        if (regex.test(replacedText)) {
          const linkText = entry.name.replace(regex, `<a href="${href}">$1</a>`);
          const key = `#${ei}`;
          matchMap[key] = linkText;
          replacedText = replacedText.replace(regex, key); // 将匹配到的链接地址替换为链接
        }
      }

      if (replacedText !== text) {
        for (const key in matchMap) {
          const regex = new RegExp(`(${escapeRegExp(key)})`, "g");
          replacedText = replacedText.replace(regex, matchMap[key]);
        }
        const fragment = document.createRange().createContextualFragment(replacedText);
        if (node.parentNode) {
          node.parentNode.replaceChild(fragment, node);
        }
      }
    }
    // 如果节点是元素节点，则递归处理其子节点
    else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.childNodes && node.childNodes.length > 0) {
        loopDomNode(node, entryList, gameAlias, id);
      }
    }
  }
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
